var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mb-4",attrs:{"variant":"info"},on:{"click":_vm.newModel}},[_c('b-icon-person-plus-fill',{staticClass:"mr-1"}),_vm._v(" 新しいメンバー ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }